module.exports = __webpack_public_path__ + "static/media/Group.69f5346e.png";